import { render } from "./WorldList.vue?vue&type=template&id=02b8b59d&scoped=true&bindings={}"
import script from "./WorldList.vue?vue&type=script&lang=ts"
export * from "./WorldList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-02b8b59d"

export default script